import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//redux stuff
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
//redux reducers
import  authReducer  from './features/auth';
import  exhibitorReducer  from './features/exhibitor';
import  fasciaReducer  from './features/fascia';
import  loginUsernameReducer  from './features/loginUsername';
import  loginPasswordReducer  from './features/loginPassword';
import  userReducer  from './features/user';


const store = configureStore({
  reducer:{
    fascia:fasciaReducer,
    auth:authReducer,
    exhibitor:exhibitorReducer,
    loginUsername:loginUsernameReducer,
    loginPassword:loginPasswordReducer,
    user:userReducer
  }
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
